import 'babel-polyfill';
import stickybits from 'stickybits';

require('script-loader!.tmp/js/templates/components/Util/Util.js');
require('script-loader!.tmp/js/templates/components/Maps/Maps.js');
require('script-loader!.tmp/js/templates/components/Maps/GetDirections.js');
require('script-loader!.tmp/js/templates/components/address/address.js');
require('script-loader!.tmp/js/templates/components/address/i18n.js');
require('script-loader!.tmp/js/templates/components/address/fields.js');
require('script-loader!.tmp/js/templates/components/phone/phone.js');
require('script-loader!.tmp/js/templates/components/search/search.js');
require('script-loader!.tmp/js/templates/components/LocationHours/LocationHours.js');
require('script-loader!.tmp/js/templates/common/helpers.js');
require('script-loader!.tmp/js/templates/common/modules/Teaser.js');
require('script-loader!.tmp/js/templates/search/modules/search-box.js');
require('script-loader!.tmp/js/templates/search/modules/Ace.js');
require('script-loader!.tmp/js/templates/search/modules/App_Promo_Banner.js');
require('script-loader!.tmp/js/templates/components/Cobalt/Teaser.js');
require('script-loader!.tmp/js/templates/common/modules/Footer.js');
require('script-loader!.tmp/js/templates/common/modules/LocationName.js');
require('script-loader!.tmp/js/templates/url/url.js');
require('script-loader!.tmp/js/templates/search/modules/helpers.js');
require('script-loader!.tmp/js/templates/search/modules/results.js');

import { Maps } from 'js/components/Maps/index.js'
import { Form } from 'js/components/Cobalt/Locator/Form.js';
import { FilterModal } from 'js/search/modules/FilterModal.js';

import { PanButton } from 'js/search/modules/PanButton.js';
import { AceMap, MapSetup } from 'js/search/modules/LocatorAceMapGoogle.js';
import { Locator } from 'js/search/modules/LocatorGoogle.js'
window.Yext.Maps = { AceMap: AceMap};

export class LocatorAce {
  constructor() {}

  static init(options) {
    options = options || {};
    Maps.loadAndRun();
    MapSetup();

    const formEl = document.getElementById('search-form');
    const formSubmitter = document.getElementById('js-form-submit');
    const filtersEl = document.getElementById('filters')
    const externalInputEls = filtersEl ? filtersEl.querySelectorAll('input,select') : [];

    const filterModalOpenEl = document.getElementById('js-filters-open');
    const filterModal = filtersEl ? new FilterModal(filtersEl, filterModalOpenEl) : null;
    const form = new Form(formEl, formSubmitter, externalInputEls);

    // Polyfill for position sticky on IE.
    // This only works on mobile. It works on the body but can't handle overflowing containers.
    stickybits('.js-stickybits', {noStyles: true});
    const locatorEl = document.getElementById('js-locator');
    const locatorAce = new Locator(locatorEl,
            form,
            search.cobalt.locator.ace_initial,
            search.cobalt.locator.ace_results,
            filterModal && filterModal.updateFilterCount.bind(filterModal),
            options.afterRender);

    const researchFunction = (map, center) => {
      let formValues = form.serialize()
      let params = new URI(`?${formValues}`);
      params.removeSearch('q');
      params.addSearch('q', `${center.lat},${center.lng}`);
      locatorAce.searchAndRender(params.query());
    };

    const researcher = new PanButton(researchFunction, {
      buttonClass: 'Locator-researchButton',
    });

    if (options.useReSearchButton) {
      for (const instance of AceMap.instances) {
        instance.element.addEventListener('map.prepared', () => {
          researcher.addToMap(instance.map, instance.element);
        });
      }
    }
  }
}
